import React from "react";
import PropTypes from "prop-types";

import { Box, CircularProgress, Typography } from "@/components";

const Progress = (props) => {
  const { loading = false, title, subtitle, children } = props;

  if (!loading) {
    return children;
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      paddingTop={8}
      paddingBottom={8}
    >
      <CircularProgress />
      {title && (
        <Typography
          variant="h6"
          fontWeight="bold"
          color="secondary"
          marginTop={2}
        >
          {title}
        </Typography>
      )}
      {subtitle && <Typography variant="subtitle1">{subtitle}</Typography>}
    </Box>
  );
};

Progress.propTypes = {
  children: PropTypes.node,
  loading: PropTypes.bool,
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

export default Progress;
